var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Upload = function Upload(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 15 15' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'g',
        { fill: 'currentColor', fillRule: 'evenodd' },
        React.createElement('path', { d: 'M14 8.037v3.5c0 .827-.673 1.5-1.5 1.5h-10c-.827 0-1.5-.673-1.5-1.5v-3.5H0v3.5c0 1.378 1.122 2.5 2.5 2.5h10c1.378 0 2.5-1.122 2.5-2.5v-3.5h-1z' }),
        React.createElement('path', { d: 'M7 1.623v9.414h1V1.623l2.718 2.698.564-.568L7.5 0 3.718 3.753l.564.568z' })
      )
    )
  );
};
/*eslint-enable */

export default Upload;
//# sourceMappingURL=Upload.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Upload.js